import { c as _c } from "react/compiler-runtime";
import classNames from '@/utils/classNames';
export const mainLayoutClassName = ['w-full', 'h-screen', 'group-[.full]/modal:h-[calc(100vh-var(--modal-padding))]', 'grid',
// Not sure if this should be defined here...
'*:data-[slot=header]:border-b', '*:data-[slot=header]:border-stone-200', '*:data-[slot=header]:px-6', '*:data-[slot=header]:py-4',
// Default setup with only main content
'grid-rows-1', 'grid-cols-[1fr]', '[grid-template-areas:"main"]',
// Core area definitions
'*:data-[slot=main]:[grid-area:main]', '*:data-[slot=aside]:[grid-area:aside]', '*:data-[slot=header]:[grid-area:header]',
// Variant: Has header
'has-[>[data-slot=header]]:grid-rows-[auto_1fr]', 'has-[>[data-slot=header]]:[grid-template-areas:"header"_"main"]',
// Variant: Has aside
'has-[>[data-slot=aside]]:grid-cols-[1fr_auto]', 'has-[>[data-slot=aside]]:[grid-template-areas:"main_aside"]',
// Variant: Has both header and aside
'has-[>[data-slot=header]]:has-[>[data-slot=aside]]:[grid-template-areas:"header_header"_"main_aside"]'].join(' ');
const Main = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames(mainLayoutClassName, className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <section className={t1} {...props}>{children}</section>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default Main;